class CustomBtnTestimonialSlider {
	initialize() {

		const prevButton = document.getElementById('prev-listing-btn');
		const nextButton = document.getElementById('next-listing-btn');


		const prevButtonMob = document.getElementById('prev-listing-btn-mob');
		const nextButtonMob = document.getElementById('next-listing-btn-mob');



		const buttons = [prevButton, nextButton, prevButtonMob, nextButtonMob];


		buttons.forEach(button => {
			if (button) {
				button.style.cursor = 'pointer';
			}
		});


		const handleClick = (button, selector) => {
			if (button) {
				button.addEventListener('click', () => {
					const arrow = document.querySelector(selector);
					if (arrow) arrow.click();
				});
			}
		};


		handleClick(prevButton, '.testimonial-slider-2nd .jet-listing-grid__slider-icon.prev-arrow');
		handleClick(nextButton, '.testimonial-slider-2nd .jet-listing-grid__slider-icon.next-arrow');
		handleClick(prevButtonMob, '.testimonial-slider-2nd .jet-listing-grid__slider-icon.prev-arrow');
		handleClick(nextButtonMob, '.testimonial-slider-2nd .jet-listing-grid__slider-icon.next-arrow');
	}
}

export { CustomBtnTestimonialSlider };
